import MiniCard from "../../components/MiniCardUI";
import InvoicePaid from "../../assets/invoice-paid.svg";
import InvoiceNotPaid from "../../assets/invoice-bill.svg";
import EmojiCalendar from "../../assets/calendar.svg";
import EmojiMoney from "../../assets/images/money.png";
import { useEffect, useState } from "react";
import {
  getAllScreeningEvents,
  getScreeningEventStats,
  updateScreeningEvents,
} from "../../api/screeningEvent";
import moment from "moment";
import makeToast from "../../components/Snackbar";

type Stats = {
  totalEvents: number;
  factured: number;
  nonFactured: number;
  totalRevenue: number;
};
const isFilled = (v: any) => v !== null && v !== undefined && v !== "";
const isMissing = (v: any) => v === null || v === undefined || v === "";

const Facturation: React.FC = () => {
  const [stats, setStats] = useState<Stats | null>(null);
  const [events, setEvents] = useState<any[]>([]);
  const [filter, setFilter] = useState<"all" | "billed" | "unbilled">("all");
  const [editingEvent, setEditingEvent] = useState<any | null>(null);
  const [showEditModal, setShowEditModal] = useState(false);
  
  const groupByClient = (events: any[]) => {
    return events.reduce((acc: any, event) => {
      const clientName = event.clientId?.name || "Unknown";

      if (!acc[clientName]) acc[clientName] = [];
      acc[clientName].push(event);

      return acc;
    }, {});
  };

  const filterEvents = (
    events: any[],
    filter: "all" | "billed" | "unbilled"
  ) => {
    if (filter === "all") return events;

    if (filter === "billed") {
      return events.filter(
        (e) => isFilled(e.dateFacture) && isFilled(e.numeroFacture)
      );
    }

    if (filter === "unbilled") {
      return events.filter(
        (e) => isMissing(e.dateFacture) || isMissing(e.numeroFacture)
      );
    }

    return events;
  };

  const handleUpdateScreeningEvent = async (event: any) => {
    try {
      const response = await updateScreeningEvents(event._id, {
        ...event,
        dateFacture: event.dateFacture,
        numeroFacture: event.numeroFacture,
      });

      if (!response.updated_event) {
        makeToast("error", "Erreur lors de la modification de l'événement");
        return;
      }

      makeToast("success", "Événement modifié avec succès.");

      setEvents((prev) =>
        prev.map((e) => (e._id === event._id ? { ...e, ...event } : e))
      );
    } catch (error) {
      console.error(error);
      makeToast("error", "Erreur lors de la modification de l'événement");
    }
  };



  const filteredEvents = filterEvents(events, filter);
  const grouped = groupByClient(filteredEvents);

  useEffect(() => {
    async function fetchStats() {
      try {
        const statResult = await getScreeningEventStats();
        setStats(statResult);
        //console.log("statResult", statResult);
      } catch (err) {
        console.error("Failed to fetch stats:", err);
      }
    }
    fetchStats();
  }, []);

  useEffect(() => {
    async function fetchAllScreeningEvents() {
      try {
        const eventResult = await getAllScreeningEvents();
        setEvents(eventResult.response || []);
        console.log("eventResult", eventResult);
      } catch (err) {
        console.error("Failed to fetch events:", err);
      }
    }
    fetchAllScreeningEvents();
  }, []);

  if (!stats) return <p className="text-gray-500 mt-4 mx-16">Chargement...</p>;

  const displayStats = [
    {
      name: "Total journées",
      score: stats.totalEvents,
      emoji: EmojiCalendar,
      direction: "col",
    },
    {
      name: "Facturées",
      score: stats.factured,
      emoji: InvoicePaid,
      direction: "col",
    },
    {
      name: "Non facturées",
      score: stats.nonFactured,
      emoji: InvoiceNotPaid,
      direction: "col",
    },
    {
      name: "Revenus",
      score: stats.totalRevenue,
      emoji: EmojiMoney,
      direction: "col",
    },
  ];

  const openEditModal = (event: any) => {
    console.log("Edit event:", event);
    setEditingEvent(event);
    setShowEditModal(true);

    
  };

  return (
    <div className="mx-16 my-8">
      <header className="flex flex-col md:flex-row justify-between items-start md:items-center w-full flex-wrap">
        <div className="title-container">
          <h1 className="text-3xl font-bold tracking-tight">Facturation</h1>
          <h3 className="text-gray-500 mt-1 text-sm">
            Gérez vos factures et suivez vos revenus
          </h3>
        </div>
      </header>

      <div className="flex flex-wrap gap-4 mt-6">
        {displayStats.map(({ name, score, emoji, direction }) => (
          <MiniCard
            key={name}
            name={name}
            score={name === "Revenus" ? score.toString() + " €" : score.toString()}
            emoji={emoji}
            direction={direction}
          />
        ))}
      </div>

      <div className="flex justify-between items-center w-full mt-5 filtres">
        <div className="flex gap-2 bg-gray-100 p-1 rounded-xl">
          {[
            { key: "all", label: "Toutes" },
            { key: "billed", label: "Facturées" },
            { key: "unbilled", label: "Non facturées" },
          ].map((b) => (
            <button
              key={b.key}
              onClick={() => setFilter(b.key as any)}
              className={`px-4 py-2 rounded-lg text-sm font-medium transition
        ${
          filter === b.key
            ? "bg-white shadow text-blue-600"
            : "text-gray-500 hover:text-gray-700"
        }`}
            >
              {b.label}
            </button>
          ))}
        </div>
      </div>
      <div className="mt-3">
        {Object.entries(grouped).map(([clientName, clientEvents]: any) => (
          <div
            key={clientName}
            className="bg-white rounded-2xl shadow-sm border border-gray-100 p-5 mb-8"
          >
            <h2 className="text-xl font-bold mb-3">{clientName}</h2>

            <div className="overflow-x-auto rounded-xl border border-gray-200">
              <table className="w-full text-sm text-left border-collapse">
                <thead className="bg-gray-50 text-gray-600 sticky top-0">
                  <tr>
                    <th className="px-4 py-3 font-semibold">Date</th>
                    <th className="px-4 py-3 font-semibold">Lieu</th>
                    <th className="px-4 py-3 font-semibold">Tarif</th>
                    <th className="px-4 py-3 font-semibold">Date facture</th>
                    <th className="px-4 py-3 font-semibold">Numéro facture</th>
                    <th className="px-4 py-3 font-semibold text-center">
                      Actions
                    </th>
                  </tr>
                </thead>

                <tbody className="divide-y">
                  {clientEvents.map((e: any, idx: number) => {
                    const isEditable = isMissing(e.dateFacture) || isMissing(e.numeroFacture);
                    

                    return (
                      <tr
                        key={e._id}
                        className={`transition hover:bg-gray-50 ${
                          idx % 2 === 0 ? "bg-white" : "bg-gray-50/50"
                        }`}
                      >
                        <td className="px-4 py-3">
                          {moment(e.eventDate).format("DD/MM/YYYY")}
                        </td>
                        <td className="px-4 py-3">{e.lieu}</td>
                        <td className="px-4 py-3">{e.tarif ?? "-"}</td>
                        <td className="px-4 py-3">
                          {e.dateFacture
                            ? moment(e.dateFacture).format("DD/MM/YYYY")
                            : "—"}
                        </td>
                        <td className="px-4 py-3">{e.numeroFacture || "—"}</td>
                        <td className="px-4 py-3 text-center">
                          {isEditable ? (
                            <button
                              onClick={() => openEditModal(e)}
                              className="inline-flex items-center gap-1 px-3 py-1.5 text-xs font-medium rounded-lg bg-blue-50 text-blue-600 hover:bg-blue-100 transition"
                            >
                              Modifier
                            </button>
                          ) : (
                            <span className="text-gray-400 text-xs">—</span>
                          )}
                        </td>
                      </tr>
                    );
                  })}
                </tbody>
              </table>
            </div>
          </div>
        ))}
      </div>

      {showEditModal && editingEvent && (
  <div className="fixed inset-0 bg-black/40 z-50 flex items-center justify-center">
    <div className="bg-white rounded-2xl shadow-lg p-6 w-full max-w-md">
      <h3 className="text-lg font-bold mb-4">Modifier la facture</h3>

      <div className="space-y-4">
        <div>
          <label className="text-sm text-gray-500">Date de facture</label>
          <input
            type="date"
            className="w-full border rounded-lg px-3 py-2"
            value={
              editingEvent.dateFacture
                ? moment(editingEvent.dateFacture).format("YYYY-MM-DD")
                : ""
            }
            onChange={(e) =>
              setEditingEvent({
                ...editingEvent,
                dateFacture: e.target.value
                  ? moment(e.target.value, "YYYY-MM-DD").toDate()
                  : null,
              })
            }
          />
        </div>

        <div>
          <label className="text-sm text-gray-500">Numéro de facture</label>
          <input
            type="text"
            className="w-full border rounded-lg px-3 py-2"
            value={editingEvent.numeroFacture || ""}
            onChange={(e) =>
              setEditingEvent({
                ...editingEvent,
                numeroFacture: e.target.value,
              })
            }
          />
        </div>
      </div>

      <div className="flex justify-end gap-3 mt-6">
        <button
          className="px-4 py-2 rounded-lg text-gray-600 hover:bg-gray-100"
          onClick={() => {
            setShowEditModal(false);
            setEditingEvent(null);
          }}
        >
          Annuler
        </button>

        <button
          className="px-4 py-2 rounded-lg bg-blue-600 text-white hover:bg-blue-700"
          onClick={async () => {
            if (!editingEvent) return;

            await handleUpdateScreeningEvent(editingEvent);

            setShowEditModal(false);
            setEditingEvent(null);
          }}
        >
          Enregistrer
        </button>
      </div>
    </div>
  </div>
)}
    </div>
  );
};

export default Facturation;
